import SinpeMovil from "./SinpeMovil";
import Yappy from "./Yappy";

export default { Yappy, SinpeMovil };
